import { render, staticRenderFns } from "./UserOrgForm.vue?vue&type=template&id=0665a89b&scoped=true&"
import script from "./UserOrgForm.vue?vue&type=script&lang=js&"
export * from "./UserOrgForm.vue?vue&type=script&lang=js&"
import style0 from "./UserOrgForm.vue?vue&type=style&index=0&id=0665a89b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665a89b",
  null
  
)

export default component.exports